import "./headerStyle.css";

function Header({ light, lightSwitch }) {
  return (
    <div className="lightHeader">
      <p>{light ? "Light" : "Dark"} mode</p>
      <button
        className={light ? "lightBackgroundButton" : "darkBackgroundButton"}
        onClick={lightSwitch}
      ></button>
      <div className={light ? "lightToggle" : "darkToggle"}></div>
    </div>
  );
}
export default Header;
